import { Component, Input } from '@angular/core';

@Component({
  selector: 'cerrix-subtitle',
  templateUrl: './cerrix-subtitle.component.html',
  styleUrls: ['./cerrix-subtitle.component.scss']
})
export class CerrixSubtitleComponent {
  @Input() text : string
}
